import { render } from "./HeaderMobile.vue?vue&type=template&id=4fb2d35c"
import script from "./HeaderMobile.vue?vue&type=script&lang=js"
export * from "./HeaderMobile.vue?vue&type=script&lang=js"

import "./HeaderMobile.vue?vue&type=style&index=0&id=4fb2d35c&lang=css"

import exportComponent from "/home/timobile/gitlab_gamotions/gamotions-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__